import { useMutation } from '@tanstack/react-query';
import * as Api from '../api';
import * as Types from '../types';

/** Authenticated: phone users add an email and receive a verification code. */
export const useAddEmail = () =>
  useMutation({
    mutationFn: async (values: Types.IApi.AddEmail.Request) => {
      const { data } = await Api.AddEmail(values);
      return data;
    },
  });
